import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { FileText as ScrollText, ShieldCheck } from "@phosphor-icons/react";

export default function Terms() {
  const [terms, setTerms] = useState(null);
  useEffect(() => { api.get("/legal/terms").then(({ data }) => setTerms(data)); }, []);

  return (
    <div className="max-w-[1000px] mx-auto px-6 lg:px-10 py-16" data-testid="terms-page">
      <div className="flex items-center gap-3 mb-3">
        <ScrollText size={16} weight="bold" className="text-brand-red" />
        <span className="text-[10px] tracking-[0.4em] uppercase text-brand-red">◢ LEGAL</span>
      </div>
      <h1 className="font-display font-black uppercase tracking-tighter text-5xl sm:text-6xl leading-[0.9] mb-6">
        TERMS OF <span className="text-brand-red neon-red">SERVICE.</span>
      </h1>
      {terms && (
        <div className="text-[10px] tracking-[0.3em] uppercase text-ink-dim mb-10 flex items-center gap-3">
          <span>VERSION {terms.version}</span>
          <span>·</span>
          <span>UPDATED {terms.updated_at}</span>
          <ShieldCheck size={12} weight="bold" className="text-brand-green ml-2" />
        </div>
      )}
      <div className="border border-zinc-800 bg-bg-surface grain p-8 lg:p-10" data-testid="terms-content">
        {terms ? (
          <div className="prose prose-invert max-w-none font-mono text-sm text-ink-mute leading-relaxed">
            {terms.content.split("\n").map((line, i) => {
              if (line.startsWith("# ")) return <h2 key={i} className="font-display text-3xl font-black uppercase tracking-tighter text-white mt-0 mb-6">{line.slice(2)}</h2>;
              if (line.startsWith("## ")) return <h3 key={i} className="font-display text-xl font-bold uppercase tracking-tight text-brand-red mt-8 mb-3">{line.slice(3)}</h3>;
              if (line.startsWith("**")) return <p key={i} className="text-white font-bold mt-4">{line.replaceAll("**", "")}</p>;
              if (line.startsWith("- ")) return <li key={i} className="ml-5 list-disc">{line.slice(2)}</li>;
              if (line.trim() === "") return <br key={i} />;
              return <p key={i} className="mb-3">{line}</p>;
            })}
          </div>
        ) : (
          <div className="text-ink-dim">LOADING…</div>
        )}
      </div>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/auth?mode=signup" className="bg-brand-red text-black text-xs font-bold tracking-[0.25em] uppercase px-6 py-3.5 hover:bg-white btn-glitch clip-arrow-r" data-testid="terms-signup-cta">
          AGREE & CREATE ACCOUNT ▸
        </Link>
        <Link to="/" className="border border-zinc-700 text-xs font-bold tracking-[0.25em] uppercase px-6 py-3.5 hover:border-brand-red hover:text-brand-red">
          ← BACK
        </Link>
      </div>
    </div>
  );
}
